import { render, staticRenderFns } from "./withdrawHistory.vue?vue&type=template&id=508cca14&scoped=true&"
import script from "./withdrawHistory.vue?vue&type=script&lang=js&"
export * from "./withdrawHistory.vue?vue&type=script&lang=js&"
import style0 from "./withdrawHistory.vue?vue&type=style&index=0&id=508cca14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508cca14",
  null
  
)

export default component.exports